export default __webpack_public_path__ + "static/media/star-mobile.3fec59a9.svg";